<template>
  <v-slide-y-transition>
    <v-card v-show="visible" class="filter-contaienr scrollable-container">
      <v-card-text class="overflow-y-auto flex-grow">
        <v-subheader class="pl-0">性別</v-subheader>
        <v-radio-group
          class="flex-wrap mt-2 mb-2"
          v-model="gender"
          :column="false">

          <v-radio
            class="radio"
            :key="index"
            v-for="(g, index) in genderOptions"
            :label="g.text"
            :value="g.value" />
        </v-radio-group>

        <v-subheader class="pl-0">學制</v-subheader>
        <v-radio-group
          class="flex-wrap mt-2 mb-2"
          v-model="schoolSystem"
          :column="false">

          <v-radio
            class="radio"
            :key="index"
            v-for="(s, index) in schoolSystemOptions"
            :label="s.text"
            :value="s.value" />
        </v-radio-group>

        <v-subheader class="pl-0">科目</v-subheader>
        <v-radio-group
          class="flex-wrap mt-2 mb-2"
          v-model="subject"
          :column="false">

          <v-radio
            class="radio animate-fadeIn-highlight "
            :key="index"
            v-for="(s, index) in schoolSystemSubjectOptions"
            :label="s.text"
            :value="s.value" />
        </v-radio-group>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click.stop="visible = false"
          flat>
          關閉
        </v-btn>
        <v-btn
          color="primary"
          @click.stop="query"
          flat>
          確認
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-slide-y-transition>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      visible: false
    };
  },

  computed: {
    ...mapGetters({
      schoolSystemOptions: 'schoolSystemOptions'
    }),

    ...mapGetters('teacher', {
      schoolSystemSubjectOptions: 'schoolSystemSubjectOptions'
    }),

    genderOptions() {
      return [{text: '不限', value: null}].concat(this.$store.getters.genderOptions);
    },

    name: {
      get() {
        return this.$store.state.teacher.filter.name;
      },
      set(value) {
        if (value === this.name) {
          return;
        }
        this.$store.commit('teacher/updateFilter', {name: value});
      }
    },

    gender: {
      get() {
        return this.$store.state.teacher.filter.gender;
      },
      set(value) {
        if (value === this.gender) {
          return;
        }
        this.$store.commit('teacher/updateFilter', {gender: value});
      }
    },

    schoolSystem: {
      get() {
        return this.$store.state.teacher.filter.schoolSystem;
      },
      set(value) {
        if (value === this.schoolSystem) {
          return;
        }
        this.$store.commit('teacher/updateFilter', {schoolSystem: value});
      }
    },

    subject: {
      get() {
        return this.$store.state.teacher.filter.subject;
      },
      set(value) {
        if (value === this.subject) {
          return;
        }
        this.$store.commit('teacher/updateFilter', {subject: value});
      }
    }
  },

  watch: {
    schoolSystem(newValue, oldValue) {
      if (newValue !== null) {
        this.subject = null;
      }
    }
  },

  methods: {
    toggle() {
      return this.visible = !this.visible;
    },

    query() {
      this.visible = false;
      this.$emit('query', {
        name: this.name,
        gender: this.gender,
        subjectId: this.subject,
        schoolSystemId: this.schoolSystem
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.filter-contaienr {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.radio {
  min-width: 120px;
  margin-bottom: 0.5rem;
}
</style>

